
export const RQ_GET_USER_BY_ID_API = {
  url: 'api/v1/user/<%= id %>/lookup',
  method: 'GET',
  auth: true,
};

export const RQ_UPDATE_PROFILE_API = {
  url: 'api/v1/user/<%= id %>/update/profile',
  method: 'PUT',
  auth: true,
};
